<template>
  <div class="mp-qr-wrap">
    <div class="info-item">
      <div class="info-header">毒霸企业版小程序</div>
      <div class="info-content mp-qr">
        <img src="./_images/mp-qr.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>
@import '@/assets/scss/varibles.scss';

.mp-qr-wrap {
  padding: 6px;
  box-sizing: border-box;
  font-size: 14px;

  .info-item {
    & + .info-item {
      &::before {
        content: '';
        display: block;
        height: 1px;
        width: 100%;
        margin: 16px 0;
        background: var(--cm-color-border-lighter);
      }
    }

    .info-header {
      color: $color-title-8;
      margin-bottom: 10px;
    }
  }

  .mp-qr {
    text-align: center;
    img {
      overflow: hidden;
      border-radius: 999px;
      width: 100%;
    }
  }
}
</style>
